module.exports = __webpack_public_path__ + "static/media/usd-square.f33a0174.svg";